import { AES_ENCRYPTION_ALGO_PARAMS, arrayToAesKey, verifyPublicPrivateKeyPair, } from '@lucidlink/ts-crypto/crypto';
import { TimeCachedValue } from '#sdk/utils/time-cached-value';
import { InvalidCryptoError } from '../workspace-crypto.error';
export class MemberCrypto {
    getWorkspaceCommonKey() {
        return this.workspaceCommonKey.get();
    }
    getCurrentMemberForLogging(additionalLoggingParam = {}) {
        return {
            currentMember: {
                workspaceId: this.member.workspace.id,
                memberId: this.member.id,
                invitationId: this.member.invitation.id,
            },
            ...additionalLoggingParam,
        };
    }
    async verifyPublicPrivateKeyPair(pair, errorText, additionalLoggingParam) {
        const isVerified = await verifyPublicPrivateKeyPair(pair);
        if (!isVerified) {
            this.logger.error(this.getCurrentMemberForLogging(additionalLoggingParam), errorText);
            throw new InvalidCryptoError(errorText);
        }
    }
    workspaceCommonKey = new TimeCachedValue(async () => arrayToAesKey(await this.getWorkspaceCommonKeyArray(), AES_ENCRYPTION_ALGO_PARAMS), { expirationTime: 'neverExpire' });
}
